import * as React from 'react'

export const ClickAndCollectModal = () => {
  return <p>Click and collect modal</p>
}
